var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"report-card h-100"},[_c('b-card-body',{staticClass:"d-flex h-100 align-items-center justify-content-between"},[_c('h4',{staticClass:"d-inline-block mr-3"},[_vm._v(_vm._s(_vm.report.title))]),_c('i',{class:['text-34 float-right text-dark', _vm.report.icon]})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }